<template>
    <div :style="containerStyle">
        <img src="./assets/silh_with_neck.png" class="overlay" alt="">
        <!-- <div class='bboxStyle'/> -->
    </div>
</template>

<script>
export default {
    name: 'bounding-box-view',
    props: {'result': Object, 'aspectRatio': Number},
    setup() {

    },
    watch: {
        result(val) {
            this.videoWidth = this.$parent.$refs.videoContainer.clientWidth;
            this.videoHeight = this.$parent.$refs.videoContainer.clientHeight;
            this.videoOffsetTop = this.$parent.$refs.videoContainer.offsetTop;
            this.videoOffsetLeft = this.$parent.$refs.videoContainer.offsetLeft;

            this.additionalWidth = this.aspectRatio * this.videoHeight - this.videoWidth;
            this.additionalHeight = this.videoWidth / this.aspectRatio - this.videoHeight;
            if(this.additionalWidth < 0) {
                this.additionalWidth = 0;
            }
            else if (this.additionalHeight < 0) {
                this.additionalHeight = 0;
            }
            // mediapipe
            // this.width = val.faceBox.width * (this.videoWidth+this.additionalWidth);
            // this.height = val.faceBox.height * (this.videoHeight+this.additionalHeight);
            // this.left = this.videoWidth * (val.faceBox.xCenter) - (this.width) / 2.0;
            // this.top = this.videoHeight * val.faceBox.yCenter - this.height / 2.0;

            // face-api
            this.width = val.faceBox.width * this.videoWidth;
            this.height = val.faceBox.height * this.videoHeight;
            this.left = (val.faceBox.xCenter - val.faceBox.width / 2) * this.videoWidth;
            this.top = (val.faceBox.yCenter - val.faceBox.height / 2) * this.videoHeight;
        },
    },
    computed: {
        containerStyle() {
            const style = {
                position: 'absolute',
                left: '0px',
                top: this.videoOffsetTop + 'px',
                width:this.videoWidth + 'px',
                height:this.videoHeight + 'px', 
                transform: "scaleX(-1)",
                overflow: 'hidden',
                display: "flex",
                justifyContent: "center",
                alignItems: "center",

            }
            return style
        },
        
        // dynamic bounding box
        bboxStyle() {
            const style = {
                position:"absolute", 
                borderStyle: "solid", 
                borderWidth: "8px",
                borderColor: "#198754",
                left: this.left + 'px', 
                top: this.top + 'px', 
                width: this.width + 'px',
                height: this.height + 'px',
                "z-index": 2,
            }
            return style;
        }

        // static bounding box
        // bboxStyle() {
        //     const style = {
        //         position:"absolute", 
        //         borderStyle: "solid", 
        //         borderWidth: "8px",
        //         borderColor: "#198754",
        //         borderBottomLeftRadius: "100% 100%",
        //         borderBottomRightRadius: "100% 100%",
        //         borderTopLeftRadius: "100% 100%",
        //         borderTopRightRadius: "100% 100%",
        //         // left: this.videoWidth/2.8 + 'px', 
        //         // top: this.videoHeight/6.5 + 'px', 
        //         transform: "translate(0, -40px)",    
        //         width: 350+ 'px', 
        //         height: 450  + 'px', 
        //     }
        //     return style;
        // }
    },
    data() {
        return{
            width: 0,
            height: 0,
            left: 0,
            top: 0,
            videoWidth: 0,
            videoHeight: 0,
            videoOffsetTop: 0,
            videoOffsetLeft: 0,
            additionalWidth: 0,
            additionalHeight: 0,
        }
    }
}
</script>

<style scoped>
.bboxStyle {
    position: absolute;
    border-style: solid;
    border-width: 8px;
    border-color: #198754;
    border-bottom-left-radius: 100% 100%;
    border-bottom-right-radius: 100% 100%;
    border-top-left-radius: 100% 100%;
    border-top-right-radius: 100% 100%;
    transform: translate(0, -65px);
    width: 400px;
    height: 500px;
}

.overlay {
    object-fit: cover;
    width: inherit;
    height: inherit;
    transform: scale(1.2) translate(0, -20px);
}

@media (max-width: 480px) {
    .overlay {
        transform: scale(0.9);

    }
}

@media (max-width: 1040px) {
    .bboxStyle {
        width: 350px;
        height: 450px;
    }
    
    .overlay {
        transform: scale(1.1) translate(0px, -50px);
    }
}

@media (min-width: 2560px) {
    .overlay {
        transform: scale(1)
    }    
}
</style>